import { Receipt, Sparkles, Square, LayoutTemplate, Gem, PanelLeft } from "lucide-react";

/** Invoice PDF template options — must match backend invoice_template values. */
export const INVOICE_TEMPLATES = [
  { id: "classic", name: "Classic", desc: "Warm ivory layout with clear totals", icon: Receipt },
  { id: "modern", name: "Modern", desc: "Teal header band — clean and branded", icon: Sparkles },
  { id: "minimal", name: "Minimal", desc: "Black and white — maximum clarity", icon: Square },
  { id: "bold", name: "Bold", desc: "Dark header — strong presence", icon: LayoutTemplate },
  { id: "elegant", name: "Elegant", desc: "Gold accents with refined spacing", icon: Gem },
  { id: "stripe", name: "Stripe", desc: "Side accent bar with modern type", icon: PanelLeft },
];
